import { httpCreate } from './http';

const http = httpCreate('/srv/coupon-activity');

export const couponActivity = {
	lanternFestivalGive() {
		return http.get('/give');
	},
	// 判断是否是新用户
	getIsNewUser() {
		return http.get('/user?photoLive=0');
	},
	// 新用户领取优惠券
	getNewUserCoupon() {
		return http.get('/newUserGet?photoLive=0');
	},
};
